import { instance } from "../axios/axiosConfig";
// types
import {
  UserCompleteRegisterBodyType,
  UserForgotPasswordBodyType,
  UserSetPasswordBodyType,
  UserSignInBodyType,
} from "../types/userAuthTypes.tsx";

const userAuthApi = {
  userSignIn(body: UserSignInBodyType) {
    return instance.post(`/api/token/`, body);
  },
  userSignOut() {
    return instance.post(`/api/auth/oidc/logout/`, {
      redirect_uri: `${window.location.origin}/signin`,
    });
  },
  forgotPassword(body: UserForgotPasswordBodyType) {
    return instance.post(`/api/auth/forgot-password/`, body);
  },
  setPassword(body: UserSetPasswordBodyType) {
    return instance.post(`/api/auth/set-password/`, body);
  },
  registerCompleteUser(body: UserCompleteRegisterBodyType) {
    return instance.patch(`/api/users/register/complete/`, body);
  },
  signInWithSSOCookie(sso_token: string) {
    return instance.post(`/api/auth/sso-cookie/`, { sso_token });
  },
};

export default userAuthApi;
